const ZENDESK_BASE_URL = 'https://support.99designs.com';
export const ZENDESK_LANGUAGES = ['en', 'de', 'es', 'fr', 'it', 'ja', 'nl', 'pt'] as const;
const DEFAULT_LANGUAGE: ZendeskLanguage = 'en';

export type ZendeskLanguage = typeof ZENDESK_LANGUAGES[number]

export function getSupportArticleUrl(zendeskId: string, lang: ZendeskLanguage) {
    return `${getSupportBaseUrl(lang)}/articles/${zendeskId}`;
}

export function getSupportCategoryUrl(zendeskId: string, lang: ZendeskLanguage) {
    return `${getSupportBaseUrl(lang)}/categories/${zendeskId}`;
}

export function getSupportSectionUrl(zendeskId: string, lang: ZendeskLanguage) {
    return `${getSupportBaseUrl(lang)}/sections/${zendeskId}`;
}

export function getSupportBaseUrl(lang = DEFAULT_LANGUAGE) {
    //Convert from RFC3066 to ISO639
    lang = lang.substring(0, 2) as ZendeskLanguage;
    if (!ZENDESK_LANGUAGES.includes(lang)) {
        lang = DEFAULT_LANGUAGE;
    }
    return `${ZENDESK_BASE_URL}/hc/${lang}`;
}

export function getSupportContactUrl(lang: ZendeskLanguage, role?: 'customer') {
    const baseUrl = `${getSupportBaseUrl(lang)}/requests/new`;
    if (!role) {
        return baseUrl;
    }
    return `${baseUrl}?ticket_form_id=180343`;
}
